import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ThemeService } from '../shared/theme.service';
import { AuthService } from '../shared/auth.service';
import { LayoutService } from '../shared/layout.service';

@Component({
  standalone: true,
  selector: 'app-topbar',
  imports: [CommonModule],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  themeService = inject(ThemeService);
  layout = inject(LayoutService);

  logout(): void {
    this.auth.logout();
    this.router.navigateByUrl('/login');
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  toggleSidebar(): void {
    this.layout.toggleSidebar();
  }
}
